export default __webpack_public_path__ + "static/media/machine.dc934f96.png";